import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  WritableSignal,
  inject,
} from '@angular/core';
import { NavigationItem } from '@shared/models/navigation-item';

@Component({
  standalone: false,
  selector: 'gstar-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent implements OnInit, AfterViewInit, OnChanges {
  private element = inject(ElementRef);

  hasFooter = input<boolean>(false);
  navList = input<Array<NavigationItem>>([]);
  selectedIndex = input<number>();
  selectedSubIndex = input<number>();
  selectedNestedIndex = input<number>();
  width = input<string>('280px');
  solid = input<boolean>(false);
  collapsed = input<boolean>(false);
  @Output() clickItem: EventEmitter<NavigationItem> = new EventEmitter();

  navEle: WritableSignal<HTMLElement> = signal({} as HTMLElement);
  tempWidth: WritableSignal<string> = signal('');
  selectedIndexValue: WritableSignal<number | undefined> = signal(
    this.selectedIndex()
  );
  selectedSubIndexValue: WritableSignal<number | undefined> = signal(
    this.selectedSubIndex()
  );
  selectedNestedIndexValue: WritableSignal<number | undefined> = signal(
    this.selectedNestedIndex()
  );
  widthValue: WritableSignal<string> = signal(this.width());
  collapsedValue: WritableSignal<boolean> = signal(this.collapsed());

  hasChildren(item: NavigationItem): boolean | undefined {
    return item.children && item.children.length > 0;
  }

  isSelected(index: number, selectedIndex: number | undefined): boolean {
    return index === selectedIndex;
  }

  isItemDisabled(item: NavigationItem): boolean {
    return item.disableIf ? item.disableIf() : false;
  }

  ngOnInit(): void {
    this.tempWidth.set(this.widthValue());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedIndex']) {
      for (const propName in changes) {
        if (propName === 'selectedIndex') {
          const index: number = changes[propName].currentValue;
          this.selectedIndexValue.set(index);
        }
      }
    }
    if (changes['selectedSubIndex']) {
      for (const propName in changes) {
        if (propName === 'selectedSubIndex') {
          const index: number = changes[propName].currentValue;
          this.selectedSubIndexValue.set(index);
        }
      }
    }
    if (changes['selectedNestedIndex']) {
      for (const propName in changes) {
        if (propName === 'selectedNestedIndex') {
          const index: number = changes[propName].currentValue;
          this.selectedNestedIndexValue.set(index);
        }
      }
    }
  }

  onClickParentItem(item: NavigationItem): void {
    if (item.children && item.children.length > 0 && !this.collapsedValue()) {
      item.open = !item.open;
      return;
    }

    this.clickItem.emit(item);
  }

  onClickSubItem(subItem: NavigationItem): void {
    if (subItem.children && subItem.children.length > 0) {
      subItem.open = !subItem.open;
      return;
    }

    this.clickItem.emit(subItem);
  }

  onClickNestedItem(lastItem: NavigationItem): void {
    this.clickItem.emit(lastItem);
  }

  ngAfterViewInit(): void {
    this.navEle.set(this.element.nativeElement.firstChild as HTMLElement);

    if (this.collapsedValue()) {
      this.widthValue.set('72px');
      this.navEle().style.setProperty('--nav-width', this.widthValue());
    } else {
      this.widthValue.set(this.tempWidth());
      this.navEle().style.setProperty('--nav-width', this.widthValue());
    }
  }

  onCollapsed(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.collapsedValue.set(!this.collapsedValue());
    if (this.collapsedValue()) {
      this.widthValue.set('72px');
      this.navEle().style.setProperty('--nav-width', this.widthValue());
    } else {
      this.widthValue.set(this.tempWidth());
      this.navEle().style.setProperty('--nav-width', this.widthValue());
    }
  }
}
